import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as Styles from "@universityofmaryland/web-styles-library";
import { fullscreen as fullscreen$1 } from "@universityofmaryland/web-icons-library/controls";
const create = ({
  callback,
  index
}) => (() => {
  return new ElementBuilder("button").withAttribute("data-index", index.toString()).withAttribute("aria-label", "View Full Screen").withHTML(`Full Screen <span></span>${fullscreen$1}`).on("click", () => callback(index)).styled(Styles.element.action.button.fullScreen).build();
})();
const fullscreen = {
  create
};
export {
  fullscreen
};
//# sourceMappingURL=fullscreen.js.map
